import React, { useEffect, useState } from "react";
import { Card, Box, Typography, IconButton, Link, Grid } from "@mui/material";
import { IgniteAdmins } from "./IgniteAdmins";
import { useSelector, useDispatch } from "react-redux";
import {
  IgniteMainWrapper,
  BannerSection,
  BannerContent,
  BannerTitle,
  BannerButton,
  NewBadge,
  JoinText,
  TalksWrapper,
  SectionTitle,
  VideoDescription,
  VideoStyledImg,
  IgniteWrapper,
  IgniteMedia,
  IgniteDescription,
  IgniteCardIcons,
  IgniteCardTitle,
  TransparentDialog,
  IgniteDialogTitle,
  IgniteDialogContent,
  DialogCloseBtn,
  UpcomingSessionDetails,
  UpcomingSessionTabsWrapper,
  UpcomingSessionTabs,
  UpcomingSessionRegisterBtn,
  NoSearchData,
  IgniteCardActions,
  AddCardContentWrapper,
  TitleWrapper,
} from "styles/igniteTalks.styles";
import IgniteSearch from "./IgniteSearch";
import TalksSectionWrapper from "./TalksWrapper";
import AddCardContent from "./AddCardContent";
import DeleteSessionsCardDialog from "./DeleteSessionsCardDialog";
import {
  getMostPopularData,
  getUpcomingSessions,
} from "../../Redux/IgniteTalks";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteCardDialog from "./DeleteCardDialog";
import AddUpComingCardContent from "./AddUpcomingCardContent";
import { BASE_API_URL } from "utils/constants";

import IgniteVideoContent from "./IgniteVideoContent";
import { igniteTalkAssets } from "../../imagesData/ImagesData";
import useFetchImageUrls from "../../ConstantUseFetchImageUrls";

const IgniteTalksContent = ({ activeAccount }) => {
  const [selectedTalk, setSelectedTalk] = React.useState(null);
  const [value, setValue] = React.useState(0);
  const isDataLoaded = useSelector(
    (state) => state.IgniteTalks?.isLoaded || false
  );
  const mostPolularTalksData = useSelector(
    (state) => state.IgniteTalks?.mostpopularTalksData || []
  );
  const upcomingSessionsData = useSelector(
    (state) => state.IgniteTalks?.upcomingSessionsData || []
  );
  const dispatch = useDispatch();
  const loggedInUser = activeAccount.idTokenClaims.enterpriseID;
  const [searchTalkData, setSearchTalkData] = React.useState([]);
  const [openAddContentDialog, setOpenAddContentDialog] = useState(null);
  const [openAddSessionContentDialog, setOpenAddSessionContentDialog] =
    useState(null);
  const [isDeleteCardDialog, setIsDeleteCardDialog] = useState(null);
  const [isDeleteSessionCardDialog, setIsDeleteSessionCardDialog] =
    useState(null);
  const [deleteTalkCardId, setDeleteTalkCardId] = useState(null);
  const [deleteSessionCardId, setDeleteSessionCardId] = useState(null);
  const [editCardContent, setEditCardContent] = useState([]);
  const [editSessionCardContent, setEditSessionCardContent] = useState([]);
  const [searchUpcomingSessionsData, setSearchUpcomingSessionsData] =
    React.useState(upcomingSessionsData);
  const [isDataSearched, setIsDataSearched] = React.useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const isUpcomingData = searchUpcomingSessionsData?.length > 0;

  useEffect(() => {
    dispatch(getMostPopularData());
    dispatch(getUpcomingSessions());
  }, [dispatch]);

  useEffect(() => {
    setSearchTalkData(mostPolularTalksData);
    setSearchUpcomingSessionsData(upcomingSessionsData);
  }, [mostPolularTalksData, upcomingSessionsData]);

  const query = `params=${encodeURIComponent(JSON.stringify(igniteTalkAssets))}`;
  const { imageUrls, error } = useFetchImageUrls(query);

  const urls = imageUrls?.imageUrl || {};

  if (error) return <div>Error loading assets.</div>;
  if (!imageUrls || Object.keys(imageUrls).length === 0) return null;

  return (
    <>
      <div className="few-pages-banner-wrap">
        <img
          // src={
          //   process.env.PUBLIC_URL +
          //   "/Assets/AllBanners/ignite-talks-banner-latest.png"
          // }
          src={urls["bannerIgniteTalks"]}
          alt="Ignite banner"
          className="banner-img"
        />
        <div className="few-pages-banner-box">
          <div className="few-pages-banner-content">
            <h1 className="banner-main-head">
              Expert perspectives. Real experience.
            </h1>
            <p className="banner-sub-text">
              Focused exploration that unpacks ideas with clarity and depth.
              Built to sharpen insight and make you future-ready.
            </p>
          </div>
        </div>
      </div>

      {/* <IgniteSearch
        searchTalkData={searchTalkData}
        setSearchTalkData={setSearchTalkData}
        searchUpcomingSessionsData={searchUpcomingSessionsData}
        setSearchUpcomingSessionsData={setSearchUpcomingSessionsData}
        setIsDataSearched={setIsDataSearched}
        mostPolularTalksData={mostPolularTalksData}
        upcomingSessionsData={upcomingSessionsData}
      /> */}
      {/**
      <TalksWrapper>
        {!isDataSearched && <TalksSectionWrapper />}
        {searchTalkData.length === 0 && !isDataSearched && IgniteAdmins && IgniteAdmins.includes(loggedInUser) && (
          <TitleWrapper mt={2}>
            <SectionTitle> Most Popular Talks </SectionTitle>
            <AddCardContentWrapper
              onClick={() => setOpenAddContentDialog(true)}
              variant="contained"
            >
              Add Talks
            </AddCardContentWrapper>
          </TitleWrapper>
        )}
        {searchTalkData.length > 0 && (
          <Box sx={{ mt: "20px" }}>
            <TitleWrapper>
              <SectionTitle> Most Popular Talks </SectionTitle>
              {IgniteAdmins && IgniteAdmins.includes(loggedInUser) && (
                <AddCardContentWrapper
                  onClick={() => setOpenAddContentDialog(true)}
                  variant="contained"
                >
                  Add Talks
                </AddCardContentWrapper>
              )}
            </TitleWrapper>
            <IgniteWrapper>
              {searchTalkData?.map((talk, index) => (
                <Card sx={{ height: "auto", width: "100%" }}>
                  <IgniteMedia
                    sx={{ height: 140 }}
                    image={`${process.env.PUBLIC_URL}/Assets/IgniteTalks/popularTalksImg1.jpg`}
                    title="Most Popular Talk"
                  />
                  <Box key={index} sx={{ padding: "10px" }}>
                    <IgniteCardTitle>
                      {talk.title.length > 50
                        ? (console.log("--> ", talk.title.length),
                          (
                            <>
                              {talk.title.substring(0, 50)}
                              <Typography
                                component="span"
                                title="Know more"
                                sx={{ color: "blue", cursor: "pointer" }}
                                onClick={() => setSelectedTalk(talk)}
                              >
                                ...
                              </Typography>
                            </>
                          ))
                        : talk.title}
                    </IgniteCardTitle>
                    <IgniteDescription>
                      {talk.description.length > 210 ? (
                        <>
                          {talk.description.substring(0, 210)}
                          <Typography
                            component="span"
                            title="Know more"
                            sx={{
                              color: "blue",
                              cursor: "pointer",
                              fontSize: "12px",
                            }}
                            onClick={() => setSelectedTalk(talk)}
                          >
                            ...Knowmore
                          </Typography>
                        </>
                      ) : (
                        talk.description
                      )}
                    </IgniteDescription>
                    <TransparentDialog
                      open={Boolean(selectedTalk)}
                      onClose={() => setSelectedTalk(null)}
                      fullWidth
                    >
                      <IgniteDialogTitle>
                        {selectedTalk?.title}
                        <DialogCloseBtn
                          title="Close"
                          variant="contained"
                          onClick={() => setSelectedTalk(null)}
                        >
                          X
                        </DialogCloseBtn>
                      </IgniteDialogTitle>
                      <IgniteDialogContent>
                        <Typography>{selectedTalk?.description}</Typography>
                      </IgniteDialogContent>
                    </TransparentDialog>
                    <IgniteCardIcons>
                      <VideoDescription>
                        <Typography sx={{ color: "black", fontSize: 10 }}>
                          <VideoStyledImg
                            src={`${process.env.PUBLIC_URL}/Assets/IgniteTalks/durationIcon.svg`}
                          />
                          {talk.hours > 0
                            ? `${talk.hours} hrs ${talk.minutes} mins`
                            : `${talk.minutes} mins`}
                        </Typography>
                        <Typography sx={{ color: "black", fontSize: 10 }}>
                          <VideoStyledImg
                            src={`${process.env.PUBLIC_URL}/Assets/IgniteTalks/dateIcon.svg`}
                          />
                          {talk.talks_date}
                        </Typography>
                      </VideoDescription>
                    </IgniteCardIcons>
                    {IgniteAdmins && IgniteAdmins.includes(loggedInUser) && (
                      <IgniteCardActions>
                        <IconButton
                          title="Edit"
                          onClick={() => {
                            setOpenAddContentDialog(true);
                            setEditCardContent(talk);
                          }}
                        >
                          <BorderColorIcon
                            sx={{ width: "20px", cursor: "pointer" }}
                          />
                        </IconButton>
                        <IconButton
                          title="Delete"
                          onClick={() => {
                            setIsDeleteCardDialog(true);
                            setDeleteTalkCardId(talk.id);
                          }}
                        >
                          <DeleteIcon sx={{ width: "20px", cursor: "pointer" }} />
                        </IconButton>
                      </IgniteCardActions>
                    )}
                    {isDeleteCardDialog && (
                      <DeleteCardDialog
                        isDeleteCardDialog={isDeleteCardDialog}
                        setIsDeleteCardDialog={setIsDeleteCardDialog}
                        deleteTalkCardId={deleteTalkCardId}
                      />
                    )}
                  </Box>
                </Card>
              ))}
            </IgniteWrapper>
          </Box>
        )}
        {openAddContentDialog && (
          <AddCardContent
            editCardContent={editCardContent}
            setEditCardContent={setEditCardContent}
            openAddContentDialog={openAddContentDialog}
            setOpenAddContentDialog={setOpenAddContentDialog}
          />
        )}
        {
          !isUpcomingData && !isDataSearched && IgniteAdmins && IgniteAdmins.includes(loggedInUser) && (
            <TitleWrapper mt={2}>
              <SectionTitle>Upcoming Sessions</SectionTitle>
              <AddCardContentWrapper
                onClick={() => setOpenAddSessionContentDialog(true)}
                variant="contained"
              >
                Add Sessions
              </AddCardContentWrapper>
            </TitleWrapper>
          )
        }
        {isUpcomingData && (
          <Box sx={{ mt: "20px" }}>
            {IgniteAdmins && IgniteAdmins.includes(loggedInUser) && (
              <TitleWrapper>
                <SectionTitle>Upcoming Sessions</SectionTitle>
                <AddCardContentWrapper
                  onClick={() => setOpenAddSessionContentDialog(true)}
                  variant="contained"
                >
                  Add Sessions
                </AddCardContentWrapper>
              </TitleWrapper>
            )}
            <Box sx={{ padding: "10px" }}>
              <UpcomingSessionTabsWrapper value={value} onChange={handleChange}>
                {searchUpcomingSessionsData?.map((session, index) => (
                  <UpcomingSessionTabs key={index} label={session.category} />
                ))}
              </UpcomingSessionTabsWrapper>
            </Box>
            <IgniteWrapper>
              {searchUpcomingSessionsData?.map(
                (session, index) =>
                  value === index &&
                  session?.sessions.map((sessionItem) => (
                    <Card sx={{ height: "auto", width: "100%" }}>
                      <IgniteMedia
                        sx={{ height: 140 }}
                        image={
                          (sessionItem?.session_image &&
                            `${BASE_API_URL}/${sessionItem?.session_image}`) ||
                         `${process.env.PUBLIC_URL}/Assets/IgniteTalks/popularTalksImg1.jpg`
                        }
                      />
                      <Box key={index} sx={{ padding: "10px" }}>
                        <IgniteCardTitle>
                          {sessionItem.title.length > 50 ? (
                            <>
                              {sessionItem.title.substring(0, 50)}
                              <Typography
                                component="span"
                                title="Know more"
                                sx={{ color: "blue", cursor: "pointer" }}
                                onClick={() => setSelectedTalk(session)}
                              >
                                ...
                              </Typography>
                            </>
                          ) : (
                            sessionItem.title
                          )}
                        </IgniteCardTitle>
                        <IgniteDescription>
                          {sessionItem.description.length > 210 ? (
                            <>
                              {sessionItem.description.substring(0, 210)}
                              <Typography
                                component="span"
                                title="Know more"
                                sx={{
                                  color: "blue",
                                  cursor: "pointer",
                                  fontSize: "12px",
                                }}
                                onClick={() => setSelectedTalk(session)}
                              >
                                ...Knowmore
                              </Typography>
                            </>
                          ) : (
                            sessionItem.description
                          )}
                        </IgniteDescription>
                        <TransparentDialog
                          open={Boolean(selectedTalk)}
                          onClose={() => setSelectedTalk(null)}
                          fullWidth
                        >
                          <IgniteDialogTitle>
                            {selectedTalk?.title}
                            <DialogCloseBtn
                              title="Close"
                              variant="contained"
                              onClick={() => setSelectedTalk(null)}
                            >
                              X
                            </DialogCloseBtn>
                          </IgniteDialogTitle>
                          <IgniteDialogContent>
                            <Typography
                              dangerouslySetInnerHTML={{
                                __html: selectedTalk?.description,
                              }}
                            />
                          </IgniteDialogContent>
                        </TransparentDialog>
                        <IgniteCardIcons>
                          <UpcomingSessionDetails>

                            <Typography sx={{ color: "black", fontSize: 10 }}>
                              <VideoStyledImg
                                src={`${process.env.PUBLIC_URL}/Assets/IgniteTalks/dateIcon.svg`}
                              />
                              {sessionItem.session_date}
                            </Typography>
                            <UpcomingSessionRegisterBtn>
                              <Link
                                href={sessionItem.session_link}
                                target="_blank"
                              >
                                Register Now
                              </Link>
                            </UpcomingSessionRegisterBtn>
                          </UpcomingSessionDetails>
                        </IgniteCardIcons>
                        {IgniteAdmins && IgniteAdmins.includes(loggedInUser) && (
                          <IgniteCardActions>
                            <IconButton
                              title="Edit"
                              onClick={() => {
                                setOpenAddSessionContentDialog(true);
                                setEditSessionCardContent({
                                  sessionCategory: session?.category ?? "",
                                  sessionItem,
                                });
                              }}
                            >
                              <BorderColorIcon
                                sx={{ width: "20px", cursor: "pointer" }}
                              />
                            </IconButton>
                            <IconButton
                              title="Delete"
                              onClick={() => {
                                setIsDeleteSessionCardDialog(true);
                                setDeleteSessionCardId(sessionItem.sessionId);
                              }}
                            >
                              <DeleteIcon
                                sx={{ width: "20px", cursor: "pointer" }}
                              />
                            </IconButton>
                          </IgniteCardActions>
                        )}
                        {isDeleteSessionCardDialog && (
                          <DeleteSessionsCardDialog
                            isDeleteSessionCardDialog={isDeleteSessionCardDialog}
                            setIsDeleteSessionCardDialog={setIsDeleteSessionCardDialog}
                            deleteSessionCardId={deleteSessionCardId}
                          />
                        )}
                      </Box>
                    </Card>
                  ))
              )}
            </IgniteWrapper>
          </Box>
        )}
        {openAddSessionContentDialog && (
          <AddUpComingCardContent
            editSessionCardContent={editSessionCardContent}
            setEditSessionCardContent={
              setEditSessionCardContent
            }
            openAddSessionContentDialog={
              openAddSessionContentDialog
            }
            setOpenAddSessionContentDialog={
              setOpenAddSessionContentDialog
            }
          />
        )}
        {!isUpcomingData && isDataSearched && searchTalkData.length == 0 && (
          <NoSearchData>No Data found.</NoSearchData>
        )}
      </TalksWrapper>
       */}
      <TalksWrapper>
        <div className="ignitetalks-main-wrapper">
          <IgniteVideoContent />
        </div>
      </TalksWrapper>
    </>
  );
};

export default IgniteTalksContent;
